export default __webpack_public_path__ + "static/media/register-image.64878b7c.jpg";